import { ICatalog } from "shared/hubrise/models"

export type TaxCombination = {
  delivery: number
  collection: number
  eatIn: number
}

/**
 * Return the list of tax rates combinations for the products in the catalog.
 * @param catalog
 */
export function allTaxCombinations(catalog: ICatalog): Array<TaxCombination> {
  const taxRates = new Set<string>()
  catalog.data.products.forEach((product) => {
    if (product.taxRate) taxRates.add(JSON.stringify(product.taxRate))
  })
  return Array.from(taxRates).map((taxRate) => JSON.parse(taxRate) as TaxCombination)
}
